module.exports = __webpack_public_path__ + "static/tradie-c80a654b507090d3f13435b9aa1c0b55.svg";